import React from 'react'
import PropTypes from 'prop-types'
import { IconAction, InputGroup, InputGroupAddon, LocalizedText, TimesIcon, FilterIcon, Columns } from 'labguard-cdk'
import { channelStatus } from 'src/entities'
import { useStatusFilter } from 'src/hooks'
import styles from './StatusFilter.scss'

const StatusFilter = ({ disabled }) => {
  const [status, setStatus] = useStatusFilter()
  return (
    <InputGroup>
      <InputGroupAddon disabled={disabled} icon={FilterIcon} color="light">
        <LocalizedText id="WEB_FILTER_BY_STATUS" />
      </InputGroupAddon>
      <Columns align="center" gap="0" className={styles.status}>
        {Object.entries(channelStatus).map(([id, { icon, i18n, color, group }]) => (
          <IconAction
            size="lg"
            key={id}
            tooltipPlacement="top"
            icon={icon}
            color={!disabled && status.includes(id) ? color : 'dark'}
            opacity={!disabled && status.includes(id) ? 1 : 0.2}
            tooltip={<LocalizedText id={i18n} />}
            disabled={disabled}
            onClick={() =>
              setStatus(
                status.includes(id)
                  ? status.filter(f => f !== id)
                  : [...status.filter(f => !group || channelStatus[f].group !== group), id]
              )
            }
          />
        ))}
      </Columns>
      <InputGroupAddon className={styles.reset} color="light">
        <IconAction
          icon={TimesIcon}
          disabled={disabled || !status.length}
          onClick={() => setStatus([])}
          tooltip={<LocalizedText id="WEB_RESET_FILTER" />}
        />
      </InputGroupAddon>
    </InputGroup>
  )
}

StatusFilter.propTypes = {
  disabled: PropTypes.bool,
}

export default StatusFilter
